import React from 'react'
import NavBarItem from "../components/NavBarItem"
import {tooltips} from "../constants"
import {connect} from 'react-redux'
import {runJoyride} from '../actions/index'
const Panic = ({name, icon, dispatch}) => (
    <NavBarItem tooltip={tooltips.Panic} name={name} onClick = {()=> dispatch(runJoyride(true))} icon={icon} />
)

export default connect()(Panic)